export default class ErrorMessage {
    static readonly PostQueryError: string = "Sorry, something went wrong. Please try again.";//"Service temporarily unavailable. (Error: Cannot connect to API server) Please contact support if this continues.";
}